import React, { useEffect, useState } from "react";
import { css } from "@emotion/react";
import {
  Font,
  Icon,
  TextLink,
  FieldLabel,
} from "@moneyforward/mfx_biz_react_components";
import {
  FormCheckBox,
  FormErrorMessage,
  FormTextField,
} from "@/components/molecules";
import { useIsSpMode } from "@/hooks";
import { qualifiedInvoiceIssuerRegistrationNumberValidation } from "@/components/validations";
import { useFormContext } from "react-hook-form";

type Props = {
  name: string;
  labelRequired: boolean;
};

const InnerQualifiedInvoiceIssuerRegistrationNumberFormField = (
  props: Props,
  ref: React.ForwardedRef<HTMLInputElement>
) => {
  const isSpMode = useIsSpMode();
  const [checked, setChecked] = useState<boolean>(false);
  const { watch, setValue, getValues } = useFormContext();

  const corporateNumber = watch("corporateNumber");
  useEffect(() => {
    if (checked) {
      setValue("qualifiedInvoiceIssuerRegistrationNumber", corporateNumber);
    }
  }, [corporateNumber]);

  useEffect(() => {
    const qualifiedInvoiceIssuerRegistrationNumber = getValues(
      "qualifiedInvoiceIssuerRegistrationNumber"
    );
    if (qualifiedInvoiceIssuerRegistrationNumber) {
      setChecked(true);
    }
  }, []);

  return (
    <div css={!isSpMode ? container : {}}>
      <div css={!isSpMode ? labelWrapper : spModeLabelWrapper}>
        <FieldLabel
          isRequired={props.labelRequired}
          helpMessage={
            <Font variant="s">
              「適格請求書発行事業者の登録通知書」記載の登録番号を入力してください。適格請求書発行事業者未登録（または対象外）の場合は入力不要です。
            </Font>
          }
          helpMessagePlacement="bottomLeft"
        >
          適格請求書発行事業者 登録番号
        </FieldLabel>
      </div>
      <div>
        <div css={checkBoxWrapper}>
          <FormCheckBox
            label="設定する"
            name="qualifiedInvoiceIssuerRegistrationNumberCheck"
            checked={checked}
            onClick={(e) => {
              setChecked(e.target.checked);
              if (e.target.checked) {
                setValue(
                  "qualifiedInvoiceIssuerRegistrationNumber",
                  corporateNumber
                );
              }
            }}
            bgSize="sm"
            ref={ref}
          />
        </div>
        <div css={inputNumberWrapper}>
          <div css={prefixWrapper}>
            <Font variant="m" component="p">
              T
            </Font>
          </div>
          <div css={textFieldWrapper}>
            <FormTextField
              name={props.name}
              registerOptions={{
                validate:
                  qualifiedInvoiceIssuerRegistrationNumberValidation(checked),
              }}
              disabled={!checked}
              maxLength={13}
              ref={ref}
            />
          </div>
          <div css={{ marginLeft: 16 }}>
            <TextLink
              target="_blank"
              href="https://www.invoice-kohyo.nta.go.jp/index.html"
            >
              <span css={{ display: "flex", alignItems: "center" }}>
                <span css={{ marginRight: 8 }}>登録番号検索サイト</span>
                <Icon name="openInNew" size="sm" css={{ cursor: "pointer" }} />
              </span>
            </TextLink>
          </div>
        </div>
        <div>
          <FormErrorMessage name={props.name} />
        </div>
      </div>
    </div>
  );
};

export const QualifiedInvoiceIssuerRegistrationNumberFormField =
  React.forwardRef(InnerQualifiedInvoiceIssuerRegistrationNumberFormField);

const container = css({
  display: "flex",
});

const labelWrapper = css({
  width: "176px",
  marginRight: "16px",
  paddingBottom: "4px",
});

const spModeLabelWrapper = css({
  width: "240px",
  marginRight: "16px",
  paddingBottom: "4px",
});

const inputNumberWrapper = css({
  display: "flex",
  alignItems: "center",
});

const textFieldWrapper = css({
  width: "196px",
});

const prefixWrapper = css({
  color: "#7E848E",
  marginRight: "8px",
});

const checkBoxWrapper = css({
  marginBottom: "16px",
});
